import React from "react";
import style from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={style.Footer}>
      <p>
        Created By <a href="http://georgenance.com">George Nance</a> 👨‍💻
      </p>
    </div>
  );
};

export default Footer;
